export class ResumeSellPerDay {

    balance: string;
    initialBalance: number;
    compras: number;
    ventas: number;
    comisiones: number;
    constructor({
        balance = '',
        initialBalance = '',
        compras = 0,
        ventas = 0,
        comisiones = 0
    }:any) {
        this.balance = balance;
        this.initialBalance = initialBalance;
        this.compras = compras;
        this.ventas = ventas;
        this.comisiones = comisiones;
    }
}